<template lang="pug">

    tr

        //- Draggable
        td
            i.move.icon

        //- Pub.
        td
            i.toggle.on.link.icon(
                v-on:click='hideSupplierToPurchaser()'
                v-tooltip="'Lieferant wird dem Kunden angezeigt'"
                v-show="priceModel.isSupplierVisibleForPurchaser"
            )
            i.toggle.off.link.icon(
                v-on:click='showSupplierToPurchaser()'
                v-tooltip="'Lieferant wird dem Kunden nicht angezeigt'"
                v-show="!priceModel.isSupplierVisibleForPurchaser"
            )

        //- Lieferant
        td {{ supplierModel.name }}

        //- HK + Versand
        td {{ productionPlusShippingCosts }}

        //- Verkaufpreis
        td {{ sellingPrice }}

        //- DB Gesamt
        td {{ contributionMargin }}

        //- Pr. anz.
        td
            div(v-show='canPublish')
                i.toggle.on.link.icon(
                    v-on:click='unpublishPrice()'
                    v-tooltip="'Preis wird angezeigt'"
                    v-show="priceModel.isPublished"
                )
                i.toggle.off.link.icon(
                    v-on:click='publishPrice()'
                    v-tooltip="'Preis wird nicht angezeigt'"
                    v-show="!priceModel.isPublished"
                )

            div(v-show='!canPublish')
                i.disabled.toggle.on.icon(
                    v-tooltip="'Preis wird angezeigt'"
                    v-show="priceModel.isPublished"
                )
                i.disabled.toggle.off.icon(
                    v-tooltip="'Preis kann noch nicht publiziert werden, da noch Angaben fehlen'"
                    v-show="!priceModel.isPublished"
                )

</template>

<script>
    import * as R from 'ramda'
    import { contribution_margin_sum, selling_price } from '@/utils/price'
    import { to_currency } from '@/utils/currency'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            canPublish() {
                const status = this.productModel.status
                return (
                    (status === 'IN_PROCESS' || status === "OFFERS_AVAILABLE") &&
                    this.priceModel.production > 0 &&
                    this.priceModel.id !== undefined
                )
            },

            canSupplierPublish() {
                return this.priceModel.id !== undefined
            },

            contributionMargin() {
                return R.compose(

                    // In Währungsstring konvertieren
                    // > 10
                    // < 10,00 €
                    to_currency('€'),

                    // Deckungsbetrag ermitteln
                    // > { id: 2, ... }
                    // < 10
                    contribution_margin_sum

                )(this.priceModel)
            },

            productionPlusShippingCosts() {
                return R.compose(

                    // In Währungsstring konvertieren
                    // > 115.5
                    // < 115,50 €
                    to_currency('€'),

                    // Herstellungskosten und Versandkosten addieren
                    // > { production: 100.5, shipping: 15 }
                    // < 115.5
                    priceModel => priceModel.production + priceModel.shipping

                )(this.priceModel)
            },

            sellingPrice() {
                return R.compose(

                    // Verkaufspreis in Währungs-String konvertieren
                    // > 13.1
                    // < 13,10 €
                    to_currency('€'),

                    // Verkaufspreis ermitteln
                    // > [ PriceModel, [ AdditionalCostModel, AdditionalCostModel ] ]
                    // > [ { id: 13 }, [ { amount: 2, price: 13 }, { amount: 4, price: 13 } ] ]
                    // < 13.1
                    ([ priceModel, additionalCostModels ]) => selling_price(priceModel, additionalCostModels)

                )([ this.priceModel, this.additionalCostModels ])
            }

        },

        methods: {

            publishPrice() {
                return this.patch({ id: this.priceModel.id, isPublished: true })
            },

            hideSupplierToPurchaser() {
                this.patch({ id: this.priceModel.id, isSupplierVisibleForPurchaser: false }, 'Lieferant wird dem Kunden angezeigt', 'Lieferant wird dem Kunden nicht angezeigt')
            },

            async patch(model, successMessage = 'Preis wird angezeigt', warningMessage = 'Preis wird nicht angezeigt') {
                try {
                    // Preis patchen
                    await this.$store.dispatch('prices/patch', { id: model.id, patch: model })

                    // Meldung je nach Toggle-Zustand anzeigen
                    const isOn = model.isPublished === true || model.isSupplierVisibleForPurchaser === true
                    if (isOn) {
                        this.$growl.success(successMessage)
                    } else {
                        this.$growl.warning(warningMessage)
                    }

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Preis konnte nicht gepatched werden', e)
                }
            },

            showSupplierToPurchaser() {
                this.patch({ id: this.priceModel.id, isSupplierVisibleForPurchaser: true }, 'Lieferant wird dem Kunden angezeigt', 'Lieferant wird dem Kunden nicht angezeigt')
            },

            unpublishPrice() {
                this.patch({ id: this.priceModel.id, isPublished: false })
            },

        },

        props: {

            additionalCostModels: {
                type: Array,
                required: true
            },

            priceModel: {
                type: Object,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            supplierModel: {
                type: Object,
                required: true
            }

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    .move {
        cursor: move;
    }
</style>
